<template>
  <div v-title :data-title="`视频 - 足趣社区`" class="main" v-loading="loading">
    <Header :onDownClick="openApp"/>
    <VideoContent v-if="data" v-title :data-title="`${data.note} - 足趣社区`" :data="data" :onDownClick="openApp"/>
    <VideoRecommend :list="recommendData" :onDownClick="openApp" v-loading="recommendLoading"/>
    <VideoFooter :onDownClick="openApp"/>
  </div>
</template>

<script>
import Header from '@/components/Header';
import VideoContent from './Content';
import VideoRecommend from './Recommend';
import VideoFooter from './Footer';
import OpenInstall from "../../../lib/OpenInstall";

export default {
  components: {
    Header,
    VideoContent,
    VideoRecommend,
    VideoFooter,
  },
  data: function () {
    return {
      // 视频详情是否正在加载
      loading: true,
      // 相关推荐是否正在加载
      recommendLoading: true,
      // 视频信息
      data: undefined,
      // 相关视频
      recommendData: [],
    };
  },
  created: function () {
    // 先尝试拉起
    OpenInstall.schemeWakeup();

    let videoId = this.$route.query.id;

    // 查询视频信息
    this.$axios.post(`/api/user/video/video/queryVideoDetailsById/${videoId}`).then((res) => {
      this.loading = false;
      if (res.code !== 200) {
        return;
      }
      this.data = res.data;
    });

    // 查询相关视频信息
    this.$axios.post(`/api/user/video/video/queryRelatedVideoByVideoId`, {
      number: 10,
      videoId: videoId,
    }).then((res) => {
      this.recommendLoading = false;
      if (res.code !== 200) {
        return;
      }
      this.recommendData = res.data;
    });
  },
  methods: {
    // 打开App
    openApp() {
      this.$router.push({path: "/open", query: this.$route.query});
    },
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-family: "Microsoft Yahei", arial, "Hiragino Sans GB", sans-serif;
  max-width: 500px;
  margin: auto;
}
</style>
